import { useNavigate } from 'react-router-dom';
import {
    FaAngleUp,
    FaAngleDown
} from 'react-icons/fa';

import {
    ColumnContainer,
    Subtitle,
    Table,
    TableBody,
    TableData,
    TableHead,
    TableHeader,
    TableRow
} from '../../../../styles/component.styles';

const OrdersTable = ({
    orders = [],
    sortKey = '',
    setSortKey = () => {},
    sortDirection = '',
    setSortDirection = () => {}
}) => {
    const navigate = useNavigate();

    const sortColumn = (key) => {
        if (key === sortKey) {
            if (sortDirection === 'ASC') {
                setSortDirection('DESC');
            } else if (sortDirection === 'DESC') {
                setSortDirection('');
                setSortKey('');
            } else {
                setSortDirection('ASC');
            }
        } else {
            setSortKey(key);
            setSortDirection('ASC');
        }
    };

    return (
        <ColumnContainer>
            {orders.length === 0 ?
                <Subtitle>No Orders To Display</Subtitle>
            :
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead cursor={'pointer'} onClick={() => sortColumn('status')}>
                                <ColumnContainer flexDirection={'row'}>
                                    Status
                                        {sortKey === 'status' && sortDirection === 'ASC' ?
                                                <FaAngleUp />
                                            :
                                                sortKey === 'status' && sortDirection === 'DESC' ?
                                                    <FaAngleDown />
                                                :
                                                    <ColumnContainer
                                                        minHeight={'1em'}
                                                        minWidth={'1em'}
                                                    >
                                                    </ColumnContainer>
                                        }
                                </ColumnContainer>
                            </TableHead>
                            <TableHead>
                                <ColumnContainer flexDirection={'row'}>
                                    Name
                                <ColumnContainer
                                    minHeight={'1em'}
                                    minWidth={'1em'}
                                >
                                </ColumnContainer>
                                </ColumnContainer>
                            </TableHead>
                            <TableHead>
                                <ColumnContainer flexDirection={'row'}>
                                    Ref ID
                                <ColumnContainer
                                    minHeight={'1em'}
                                    minWidth={'1em'}
                                >
                                </ColumnContainer>
                                </ColumnContainer>
                            </TableHead>
                            <TableHead cursor={'pointer'} onClick={() => sortColumn('createdAt')}>
                                <ColumnContainer flexDirection={'row'}>
                                    Date
                                        {sortKey === 'createdAt' && sortDirection === 'ASC' ?
                                                <FaAngleUp />
                                            :
                                                sortKey === 'createdAt' && sortDirection === 'DESC' ?
                                                    <FaAngleDown />
                                                :
                                                    <ColumnContainer
                                                        minHeight={'1em'}
                                                        minWidth={'1em'}
                                                    >
                                                    </ColumnContainer>
                                        }
                                </ColumnContainer>
                            </TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                    {orders.map((order, index) => {
                        const formattedDate = new Date(order.createdAt).toLocaleDateString('en-us', { day:"numeric", year:"numeric", month:"numeric"});

                        return (
                            <TableRow key={index} onClick={() => navigate(`/orders/${order.id}`)} cursor={'pointer'}>
                                <TableData>{order.status}</TableData>
                                <TableData>{order?.User?.firstName} {order?.User?.lastName}</TableData>
                                <TableData>{order?.refId}</TableData>
                                <TableData>{formattedDate}</TableData>
                            </TableRow>
                    )})}
                    </TableBody>
                </Table>
            }
        </ColumnContainer>
    )
}

export default OrdersTable;
